import React from "react";
import { useHref, useNavigate } from "react-router-dom";
import { Box, Button, Grid, Link, TextField } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import MenuItem from "@mui/material/MenuItem";
import "../cssPages/FormPag1.css";
import Container from "@mui/material/Container";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Sella from "./Sella.png";
import { useState, useEffect } from "react";
import axios from "axios";
import Url from "../services/Url";
import { useSharedStore } from "../services/SharedStore";
import "../cssPages/Logo.css";
import "../cssPages/Line.css";





const Informativa = styled(Box)({
  marginBottom: '36px',
  opacity: "0.5",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#333",
});

const CompilaCampi = styled(Box)({
  marginTop: "10px",
  marginBottom: "10px",
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.11px",
  textAlign: "center",
  color: "#7b7b7b",
});

const Intestazione = styled(Box)({
  fontFamily: "Montserrat, sans-serif",
  fontSize: "31px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: "#1b1b1b",
});

const ContactLink = styled(Link)({
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#00cb4d",
});

const HelperText = styled(Box)({
  marginTop: "168px",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#919191",
});

const SimpleBox = styled(Box)({
  textAlign: "center",
});

const UpButton = styled(Button)({
  "&:disabled": {
    backgroundColor: "#339aef",
    opacity: "0.5",
    color: "#fff",
  },
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#339aef",
  "&:hover": {
    backgroundColor: "#339aef",
  },
  "&:active": {
    backgroundColor: "#339aef",
  },
  "&:focus": {
    backgroundColor: "#339aef",
  },
});

const BackButton = styled(Button)({
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#4d606f",
  "&:hover": {
    backgroundColor: "#4d606f",
  },
  "&:active": {
    backgroundColor: "#4d606f",
  },
  "&:focus": {
    backgroundColor: "#4d606f",
  },
});

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
const CssTextFieldCF = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    height: "45px",
    "& fieldset": {
      border: "solid 1px #ccc",
    },
    "& input": {
      textTransform: "uppercase",
      padding: "12px",
    },
    "& span": {
      "font-family": "Lato",
      "font-size": "14px",
      "font-weight": "normal",
      "font-stretch": "normal",
      "font-style": "normal",
      "line-height": "normal",
      "letter-spacing": "0.1px",
      color: "#4d606f",
    },
  },
});
const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    height: "45px",
    "& fieldset": {
      border: "solid 1px #ccc",
    },
    "& input": {
      padding: "12px",
    },
    "& span": {
      "font-family": "Lato",
      "font-size": "14px",
      "font-weight": "normal",
      "font-stretch": "normal",
      "font-style": "normal",
      "line-height": "normal",
      "letter-spacing": "0.1px",
      color: "#4d606f",
    },
  },
});

const Errors = styled(Box)({
  fontFamily: "Lato",
  fontSize: "14px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.29",
  letterSpacing: "0.1px",
  color: "#f2662b",
});

function FormPagina() {
  const [loading, setloading] = useState(false);
  const PREFIX_REST_API_URL = Url + "api/prefix/";
  const AUTANTICATION_REST_API_URL = Url + "api/authenticate";
  let [codiceFiscale, setCodiceFiscaleInput] = useState("");
  let [numero, setNumeroDiCellulareInput] = useState("");
  const [prefix, setPrefix] = React.useState("+39|ITALIA");
  const { addStore } = useSharedStore();
  const [prefissi, setPrefissi] = useState([]);
  const [recaptcha, setRecaptcha] = useState("");
  const [UserError, setUserErr] = useState("");

  useEffect(() => {
    setloading(false);
    prefixx();
    window.scrollTo(0, 0);
  }, []);

  const handleAutenticate = (e) => {
    const fullNumber = (prefix.split("|")[0] + numero);
    setloading(true);
    axios.post(AUTANTICATION_REST_API_URL, {
      codiceFiscale,
      recaptcha,
      "numero": fullNumber
    }).then((res) => {
      setloading(false);
      if (res.data.response_code == "CR_1_30" && res.data.response_data != null) {
        addStore("token", res.data.response_data);
        history("/selectemail");
      } else {
        addStore("errMessage", res.data.response_desc);
        history("/errorform");
      }
    });
  }


  const prefixx = (e) => {
    axios.get(PREFIX_REST_API_URL).then(res => {
      setPrefissi(res.data.response_data);
    })
  }

  const handleValidation = (evnt) => {
    const alphabeticChar = /^[a-zA-Z]{6}[a-zA-Z0-9]{5}[a-zA-Z0-9]{4}[a-zA-Z]$/;
    const specialCharUser = alphabeticChar.test(evnt);
    let errMsg = "";
    if (!specialCharUser) {
      setUserErr("Il tuo Codice fiscale non è corretto");
    } else {
      setUserErr("");
    }
    setCodiceFiscaleInput(evnt);
  };

  function checkForDisable() {
    if (UserError != "" || codiceFiscale == "" || prefix == "" || numero == "" || recaptcha == "") {
      return true;
    } else {
      return false;
    }
  }

  const date = new Date();
  const currentYear = date.getFullYear();

  let history = useNavigate();
  return (
    <Container maxWidth="xl">
      <Grid container>
        <Grid class="logoContainer" item xs={12} sm={12} md={12}>
          <img class="logo" src={Sella}></img>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Intestazione>Recupera il tuo Codice Cliente o Username</Intestazione>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <CompilaCampi>
            Compila i campi per recuperare il Codice Cliente o Username
          </CompilaCampi>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div className="Line-1"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container spacing={1} marginTop="33px">
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={4}>
          <FormControl variant="standard" fullWidth>
            <InputLabel class="Lable" htmlFor="codiceFiscale-input">
              Codice Fiscale
            </InputLabel>
            <CssTextFieldCF
              onChange={(e) => handleValidation(e.target.value.trim())}
              variant="outlined"
              fullWidth
              type="text"
              defaultValue=""
              id="codiceFiscale-input"
            />
            <Errors>{UserError}</Errors>
          </FormControl>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </Grid>
      <br></br>
      <Grid container spacing={1}>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={4}>
              <FormControl variant="standard" fullWidth>
                <InputLabel class="Lable" htmlFor="prefisso-input">
                  Prefisso
                </InputLabel>
                <CssTextField
                  id="prefisso-input"
                  variant="outlined"
                  fullWidth
                  onChange={(e) => setPrefix(e.target.value)}
                  select
                  defaultValue={prefix}
                >
                  {prefissi.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.name}
                    </MenuItem>
                  ))}
                </CssTextField>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <FormControl variant="standard" fullWidth>
                <InputLabel class="Lable" htmlFor="cellulare-input">
                  Numero di cellulare
                </InputLabel>
                <CssTextField
                  onChange={(e) => setNumeroDiCellulareInput(e.target.value.trim())}
                  variant="outlined"
                  fullWidth
                  type="text"
                  defaultValue=""
                  id="cellulare-input"
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={0} sm={0} md={4}></Grid>
      </Grid>
      <br></br>
      <Grid container spacing={1}>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={4}>
          <FormControl variant="standard" fullWidth>
            <InputLabel class="Lable" htmlFor="recaptcha">
              Verifica la tua identità
            </InputLabel>
            <ReCAPTCHA
              hl="it"
              id="recaptcha"
              fullWidth
              sitekey="6LdTre8ZAAAAAF8Q-a5-zxHUkicW_wSmTQ3R76J9"
              onChange={(e) => setRecaptcha(e)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </Grid>
      <br></br>

      <Grid container spacing={1}>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={2}>
          <BackButton fullWidth variant="contained"
            disabled={loading}
            onClick={() => window.location.replace(window.location.origin + "/AuthenticationDelegatedServlet?delegated_service=219&SECODE=HBBE&SEACTION=LOGIN&SEPARAMS=urlBank=www.sella.it")}
          >
            INDIETRO
          </BackButton>
        </Grid>
        <Grid item xs={12} sm={12} md={2}>
          <UpButton
            fullWidth
            variant="contained"
            onClick={handleAutenticate}
            disabled={checkForDisable() || loading}
          >
            PROSEGUI
          </UpButton>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <HelperText>
            Vuoi maggiori informazioni o hai bisogno di assistenza?
          </HelperText>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SimpleBox>
            <ContactLink href="/banca-on-line/contatti-e-assistenza">contatta il servizio clienti</ContactLink>
          </SimpleBox>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div className="Line-1"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Informativa>
            © 1996-{currentYear} - Banca Sella S.p.A. - PI 02224410023 - Privacy
          </Informativa>
        </Grid>

      </Grid>
    </Container>
  );
}

export default FormPagina;
